module.exports = __webpack_public_path__ + "static/008233-fa1e0b3272fc89c2d503339364091351.jpg";